import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const BackLink = ({
    label = "Back",
    to,
    href,
    onClick,
    className = "inline-flex items-center gap-2 text-xs font-semibold text-slate-500 underline underline-offset-4 focus:outline-none",
    iconClassName = "flex h-8 w-8 items-center justify-center rounded-full bg-slate-100",
    arrowClassName = "h-4 w-4 text-slate-600",
}) => {
    const content = (
        <>
            <span className={iconClassName}>
                <ArrowLeft className={arrowClassName} />
            </span>
            {label}
        </>
    );

    if (href) {
        return (
            <a href={href} className={className}>
                {content}
            </a>
        );
    }

    if (to) {
        return (
            <Link to={to} className={className}>
                {content}
            </Link>
        );
    }

    return (
        <button type="button" onClick={onClick} className={className}>
            {content}
        </button>
    );
};

export default BackLink;
